import * as React from "react";
import { Link, useLocation } from "react-router";
import { cn } from "@/lib/utils";
import { Tooltip } from "@/components/ui/tooltip";
import { isNavigationPathActive } from "./navigationPath";

interface SidebarIconItemProps {
  href: string;
  tooltip: string | React.ReactNode;
  icon: React.ElementType;
  isActive?: boolean;
}

export const SidebarIconItem: React.FC<SidebarIconItemProps> = ({
  href,
  tooltip,
  icon: Icon,
  isActive: propIsActive,
}) => {
  const { pathname } = useLocation();
  const isActive = propIsActive ?? isNavigationPathActive(pathname, href);

  return (
    <div>
      <Tooltip text={tooltip} className="rounded bg-black text-white" side="right" delayDuration={50}>
        <Link
          to={href}
          aria-label={typeof tooltip === "string" ? tooltip : undefined}
          aria-current={isActive ? "page" : undefined}
          className={cn(
            "group flex h-10 w-10 items-center justify-center rounded-md transition-colors duration-200 ease-in-out",
            isActive ? "bg-slate-900 text-white" : "text-gray-500 hover:bg-gray-100 hover:text-gray-600",
          )}
        >
          <Icon className="h-5 w-5 shrink-0" aria-hidden="true" />
        </Link>
      </Tooltip>
    </div>
  );
};
